export default {
  manufacturerDeleteTitle: "Eliminar fabricante",
  manufacturerDeleteMessage: "¿Realmente quieres eliminar este fabricante?",
  manufacturerDeleteNotPossibleTitle: "El fabricante que está asociado con modelos de activos no puede ser eliminado.",
};
